<template>
  <el-dialog
    v-loading="loading"
    class="service-order-modal"
    width="90%"
    title="服务购买历史"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <div>
      <div v-for="s in services" :key="s.id" class="service-order">
        <div class="field">
          <label>订单编号</label><div>{{ s.SN }}</div>
        </div>
        <div class="field">
          <label>服务内容</label><div>{{ s.brands }}</div>
        </div>
        <div class="field">
          <label>生效时间</label><div>{{ s.effectTime | dateFmt }}</div>
        </div>
        <div class="field">
          <label>失效时间</label><div>{{ s.expirationTime | dateFmt }}</div>
        </div>
        <div class="field">
          <label>付款时间</label><div>{{ s.buyTime | dateTimeFmt }}</div>
        </div>
        <div class="field">
          <label>付款金额</label>
          <div>
            {{ s.sumPrice | currencyFmt }} ({{ payTypes[s.payType] }})
            <span class="pay-ex" v-if="s.couponPrice">优惠券：{{ s.couponPrice | currencyFmt }}</span>
            <span class="pay-ex" v-if="s.scorePrice">积分抵扣：{{ s.scorePrice | currencyFmt }}</span>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import { loadCustomerServiceHistory } from '../services'
export default {
  name: 'ServiceOrderHistoryModal',
  mixins: [ModalMixin],
  data () {
    return {
      loading: false,
      services: []
    }
  },
  computed: {
    payTypes () {
      return this.$store.state.payTypes
    }
  },
  methods: {
    init (companyId) {
      this.loadData(companyId)
      return this.open()
    },
    loadData (companyId) {
      this.loading = true
      loadCustomerServiceHistory(companyId).then((resp) => {
        this.services = resp
      }).catch(() => {
        this.close(false)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="stylus">
.service-order-modal
  .el-dialog
    max-width 560px
    .el-dialog__body
      padding-top 0
      max-height 640px
      overflow-x hidden
      overflow-y auto
      .service-order
        margin-bottom 8px
        position relative
        .field
          display flex
          flex-direction row
          label
            width 70px
            flex-shrink 0
            text-align right
            font-weight bold
            &:after
              content '\ff1a'
          .pay-ex
            display inline-block
            margin-left 8px
            border 1px solid #ff0000
            color #ff0000
            padding 0 6px
        +.service-order
          border-top 1px dashed #ff6600
          padding-top 8px
</style>
